import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as EMPLOYEE_ACTIONS } from "../../store/actions/employeeActions";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import "react-notifications/lib/notifications.css";
import Select from "react-select";
import { XMarkIcon } from "@heroicons/react/20/solid";
import Spinner from "../common/Spinner";
import Modal from "@/common/Modal";
import { NotificationManager } from "react-notifications";

const InviteEmployeeModal = ({ departmentOptions, closeModal, show, invitesSent, totalToSend, sendInvites }) => {
	const [department, setDepartment] = useState();

	//Show notification when all invites are sent
	useEffect(() => {
		if (!invitesSent || !show) return;
		if (invitesSent == totalToSend) {
			NotificationManager.success(
				`${invitesSent} invite${invitesSent?.length == 1 ? "" : "s"} sent to employees in ${department?.label}`,
				"Success",
				5000,
			);
		}
	}, [invitesSent]);

	return (
		<Modal
			status={show}
			close={closeModal}
			title="Invite Employees"
			width="40%"
		>
			<div
				className="block-content"
				style={{ padding: "20px 20px 1px" }}
			>
				<div className="form-group">
					{departmentOptions && (
						<div
							className="col-sm-6"
							style={{ paddingLeft: 0 }}
						>
							<label htmlFor="material-text">Department</label>
							<Select
								value={department}
								options={departmentOptions}
								onChange={(selected) => setDepartment(selected)}
								isClearable
								placeholder="Select a Department"
							/>
							<div className="clearfix" />
						</div>
					)}
				</div>
				<p
					className="col-xs-12 help-block pt-2"
					style={{ margin: 0, paddingLeft: 2 }}
				>
					Invite Employees by Department
				</p>

				<div className="clearfix" />
				<div className="block buttons">
					{invitesSent && invitesSent != totalToSend ? (
						<button
							className="btn btn-warning pull-right"
							style={{ marginRight: 0, pointerEvents: "none" }}
						>
							<Spinner
								style={{ marginRight: 10, verticalAlign: "text-bottom" }}
								className="animate-spin -ml-1 mr-3 h-7 w-7 "
							/>
							{invitesSent} / {totalToSend}
						</button>
					) : (
						<>
							<button
								className="btn btn-success pull-right"
								onClick={() => {
									sendInvites(department?.value);
								}}
								style={{ marginRight: 0, verticalAlign: "text-bottom" }}
							>
								Send Invites
							</button>
							<button
								className="btn btn-danger pull-right"
								onClick={closeModal}
							>
								Cancel
							</button>
						</>
					)}

					<div className="clearfix" />
				</div>
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const departmentOptions = state.company?.settings?.departments?.map((department) => ({
		value: department.id,
		label: department.name,
	}));

	const invitesSent = state.employees.invitesSent || 0;
	const totalToSend = state.employees.totalInvitesToSend || 0;

	return {
		invitesSent,
		totalToSend,
		departmentOptions,
		show: state.employees.inviteModal,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(EMPLOYEE_ACTIONS.showInviteEmployeeModal(false)),
	sendInvites: (department) => dispatch(EMPLOYEE_ACTIONS.sendInvites(department)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteEmployeeModal);
